<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[{ name: 'Material Gallery', to: { path: 'material-gallery' } }]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>素材圖庫</h2>
      <v-spacer></v-spacer>
      <input type="file" id="file" ref="image_upload" @change="onChange" hidden>
      <button class="btn btn-primary" @click="chooseFiles">
        <v-icon class="mr-2" color="white">add</v-icon>
        <span>新增圖片</span>
      </button>
    </div>
    <!--  -->
    <div class="block">
      <!-- head -->
      <section class="px-5">
        <h3 class="pt-5">搜尋素材</h3>
        <div class="py-5">曾於本後台上傳過的圖片，都可以在圖庫中找到</div>
        <div class="py-5 d-flex">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="選擇資料夾"
            :isOnlyShowButtonPlaceholder="true"
            buttonWidth="200px"
            modalWidth="200px"
            modalBodyHeight="208px"
            :options="categories"
            :selectedValue.sync="selectedCategory"
          ></SimpleSelectWithSearchInput>
          <div class="form-input-group flex-grow-1">
            <v-icon class="prepend-icon">search</v-icon>
            <input type="text" class="pl-42px" placeholder="依檔名搜尋" v-model="filter.keyword" />
          </div>
          <button class="btn btn-primary ml-5" @click="getImages(selectedCategory)">搜尋</button>
        </div>
      </section>
      <!-- body -->
      <section class="pt-5 pl-5 brand-100 d-flex flex-wrap">
        <div
          class="w-180px h-180px bg-center bg-contain mr-5 mb-5 gallery__image"
          v-for="img in files"
          :key="img.id"
          :style="{
            backgroundColor: '#fff',
            backgroundImage: `url(${addDomain(img.url)})`,
            position: 'relative',
          }"
        >
          <AdditionalFunction
            class="gallery__image-AdditionFunction"
            :style="{
              position: 'absolute',
              top: '10px',
              left: '138px',
              zIndex: '2',
            }"
            :imgData="img"
            :isModalShow.sync="isAdditionalFunctionModalShow"
            @remove-picture="removePicture"
            @manage-folder="manageFolder"
          ></AdditionalFunction>
        </div>
      </section>
      <ManageFolderModal
        :isModalOpen.sync="isManageFolderModalShow"
        :currentImage="currentImage"
        :folders="categories"
        @save-event="setFolder"
      ></ManageFolderModal>
      <!-- foot -->
      <section
        class="py-5 d-flex justify-center align-center v-pagination-custom"
      >
        <Pagination @handleNextPreEvent="getImages(selectedCategory)" model="filesystem">
        </Pagination>
      </section >
    </div>
  </div>
</template>

<script>
// Doc: https://vuetifyjs.com/en/components/paginations/
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import AdditionalFunction from '@/views/L_MaterialGallery/c/AdditionalFunction.vue';
import ManageFolderModal from '@/views/L_MaterialGallery/c/L-1a-1__MaterialGallery_SelectFolder.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    Breadscrumbs,
    SimpleSelectWithSearchInput,
    AdditionalFunction,
    ManageFolderModal,
    Pagination,
  },
  data: () => ({
    categories: [],
    selectedCategory: '',
    dir: '',
    // others
    isAdditionalFunctionModalShow: true,
    isManageFolderModalShow: false,
    currentImage: {},
  }),
  created() {
    this.getDirs().then((data) => {
      this.categories = data.map((o) => ({
        value: o,
        text: o,
      }));
    });
    this.getImages('');
  },
  computed: {
    ...mapState('filesystem', ['files', 'filter']),
  },
  watch: {
    selectedCategory(val) {
      this.dir = val.replace('public/', '');
      this.getImages(val);
    },
  },
  methods: {
    ...mapActions('filesystem', {
      getDirs: 'getDirs',
      createDirs: 'createDirs',
      getFiles: 'find',
      destroyFiles: 'destroy',
      moveFiles: 'save',
    }),
    ...mapActions(['upload']),
    addDomain(url) {
      if (url.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${url}`;
      }

      return url;
    },
    chooseFiles() {
      this.$refs.image_upload.click();
    },
    onChange(e) {
      e.preventDefault();
      const data = e.target.files || e.dataTransfer.files;
      if (!data.length) {
        this.isDrag = false;
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].type.indexOf('image') === -1) {
          this.setFailFileTips();
          return;
        }
      }
      this.handleFileUpload(data);
    },
    handleFileUpload(data) {
      const formData = new FormData();
      formData.append('dir', this.dir);
      for (let i = 0; i < data.length; i += 1) {
        formData.append('file', data[i], data[i].name);
      }
      this.upload(formData).then(() => {
        this.getImages(this.selectedCategory);
      });
    },

    next(page) {
      this.pagination.page = page;
    },
    async removePicture(id) {
      await this.destroyFiles(id).then(() => {
        this.getImages(this.selectedCategory);
      });
    },
    manageFolder(imgData) {
      this.isManageFolderModalShow = true;
      this.$set(this, 'currentImage', { ...imgData });
    },
    async setFolder(imgData) {
      await this.moveFiles(imgData).then(() => {
        this.getImages(this.selectedCategory);
      });
    },
    getImages(dir) {
      this.getFiles(dir);
    },
  },
};
</script>

<style lang="scss">
.gallery {
  &__image-AdditionFunction {
    display: none;
  }
  &__image:hover &__image-AdditionFunction {
    display: block;
  }
}
</style>
